document.documentElement.classList.add("mm-js-ok");
/// Cart ///
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  const cartDrawerContent = document.getElementById('CartDrawerContent');
  const closeCartDrawerButton = document.getElementById('CloseCartDrawer');
  const cartCountElement = document.getElementById('CartCount');
  const cartType = cartDrawer ? 'drawer' : (window.cartType || 'page');

  function openCartDrawer() {
    if (cartType !== 'drawer' || !cartDrawer || !cartDrawerOverlay) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    cartDrawer.classList.add('open');
    cartDrawer.style.right = '0';
    cartDrawer.style.opacity = '1';
    cartDrawer.style.visibility = 'visible';
    cartDrawer.style.display = 'flex';

    if (isDesignMode) {
      cartDrawer.style.zIndex = '999999';
    } else {
      cartDrawer.style.zIndex = '';
    }

    cartDrawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
document.body.classList.add('mm-cart-open');

updateCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawerOverlay) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    cartDrawer.classList.remove('open');
    cartDrawer.style.right = '-100%';
    cartDrawer.style.opacity = '';
    cartDrawer.style.visibility = '';
    cartDrawer.style.display = '';

    if (isDesignMode) {
      cartDrawer.style.zIndex = '';
    }

cartDrawerOverlay.classList.remove('active');

document.body.classList.remove('mm-cart-open');

document.body.style.removeProperty('overflow');
document.documentElement.style.removeProperty('overflow');

document.body.style.removeProperty('height');
document.documentElement.style.removeProperty('height');
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  if (closeCartDrawerButton) {
    closeCartDrawerButton.addEventListener('click', function () {
      closeCartDrawer();
    });
  }



function updateCartCount(cartItemCount) {

  /*
    Compteur desktop existant
  */
  if (cartCountElement) {
    cartCountElement.textContent = cartItemCount;
  }


  /*
    Tous les compteurs mobiles :
    - icône panier du header
    - bouton Panier du menu mobile
  */
  document
    .querySelectorAll('[data-mm-cart-count]')
    .forEach(function (countElement) {

      countElement.textContent =
        cartItemCount;

      /*
        Le badge de l'icône est caché
        lorsque le panier est vide.
      */
      if (
        countElement.classList.contains(
          'mm-mobile-cart-count'
        )
      ) {

        countElement.classList.toggle(
          'is-empty',
          Number(cartItemCount) === 0
        );

      }

    });

}

  function updateCartDrawerTotal() {
    const totalElement = document.querySelector('#CartDrawerTotal');
    if (!totalElement) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart drawer content');
        }
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedTotal = doc.querySelector('#CartDrawerTotal');
        if (updatedTotal) {
          totalElement.innerHTML = updatedTotal.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('Error updating cart total:', error);
      });
  }

  function removeCartItem(key, removeButton) {
    const cartItem = removeButton.closest('.cart-drawer-item');
    if (cartItem) {
      cartItem.classList.add('fade-out-bck');
    }

    setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to remove item from cart');
          }
          return response.json();
        })
        .then(function (cart) {
          updateCartDrawer();
          updateCartDrawerTotal();
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          console.error('Error removing cart item:', error);
        });
    }, 200);
  }

  function attachRemoveHandlers() {
    document.querySelectorAll('.cart-drawer-item__remove-link').forEach(function (removeButton) {
      if (removeButton.dataset.cartRemoveBound === 'true') return;
      removeButton.dataset.cartRemoveBound = 'true';

      removeButton.addEventListener('click', function (event) {
        event.preventDefault();
        const key = this.dataset.key;
        if (!key) return;
        removeCartItem(key, this);
      });
    });
  }

  function attachQuantityHandlers() {
    document.querySelectorAll('.quantity-wrapper-drawer').forEach(function (wrapper) {
      if (wrapper.dataset.cartQtyBound === 'true') return;
      wrapper.dataset.cartQtyBound = 'true';

      const key = wrapper.dataset.key;
      const inventoryQuantity = parseInt(wrapper.dataset.inventory, 10);
      const trackQuantity = wrapper.dataset.trackQuantity === 'true';
      const allowOversell = wrapper.dataset.allowOversell === 'true';

      const minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
      const plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
      const quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');

      if (!key || !quantityValue) return;

      function updateButtonStates() {
        const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;

        if (minusButton) {
          const disableMinus = currentQuantity <= 1;
          minusButton.classList.toggle('disabled', disableMinus);
          minusButton.disabled = disableMinus;
        }

        if (plusButton) {
          if (trackQuantity && !allowOversell) {
            const isMaxQuantity = currentQuantity >= inventoryQuantity;
            plusButton.classList.toggle('disabled', isMaxQuantity);
            plusButton.disabled = isMaxQuantity;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
        }
      }

      function updateCartQuantity(quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Error updating cart');
            }
            return response.json();
          })
          .then(function (cart) {
            quantityValue.textContent = quantity;
            wrapper.dataset.quantity = quantity;
            updateButtonStates();
            updateCartDrawerTotal();
            updateCartCount(cart.item_count);
          })
          .catch(function (error) {
            console.error('Error updating cart quantity:', error);
          });
      }

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (currentQuantity > 1) {
            updateCartQuantity(currentQuantity - 1);
          }
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) {
            alert('Maximum quantity for this product is ' + inventoryQuantity + '.');
          } else {
            updateCartQuantity(currentQuantity + 1);
          }
        });
      }

      updateButtonStates();
    });
  }

  function updateCartDrawer() {
    if (!cartDrawerContent) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById('CartDrawerContent');
        if (newContent) {
          cartDrawerContent.innerHTML = newContent.innerHTML;
          attachRemoveHandlers();
          attachQuantityHandlers();
        }
      })
      .catch(function (error) {
        console.error('Error updating cart drawer:', error);
      });
  }

function bindCartTriggers(root) {
  if (!root) return;

  root
    .querySelectorAll(
      'a[href*="/cart"], button[data-cart-drawer-toggle], .js-cart-toggle'
    )
    .forEach(function (cartTrigger) {
      if (cartTrigger.dataset.cartLinkBound === 'true') return;

      cartTrigger.dataset.cartLinkBound = 'true';

      cartTrigger.addEventListener('click', function (event) {
        if (cartType !== 'drawer') return;

        event.preventDefault();

        /*
          Si le panier est ouvert depuis le menu mobile,
          on ferme d'abord proprement le menu mobile.
        */
        const mobileHeaderMenu =
          document.querySelector('.header-menu');

        if (mobileHeaderMenu) {
          mobileHeaderMenu.classList.remove('active');
        }

        document.body.classList.remove(
          'mm-mobile-menu-open'
        );

        document.documentElement.classList.remove(
          'mm-mobile-menu-open'
        );
        document.body.style.removeProperty('overflow');
document.documentElement.style.removeProperty('overflow');

document.body.style.removeProperty('height');
document.documentElement.style.removeProperty('height');

        /*
          On referme aussi les éventuels sous-menus
          encore marqués comme actifs.
        */
        document
          .querySelectorAll(
            '.header-menu .menu-item.has-children.active'
          )
          .forEach(function (item) {
            item.classList.remove('active');
          });

        /*
          Puis seulement on ouvre le panier.
        */
        openCartDrawer();
      });
    });
}

  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm && !addToCartForm.dataset.cartFormBound) {
    addToCartForm.dataset.cartFormBound = 'true';

    addToCartForm.addEventListener('submit', function (event) {
      event.preventDefault();
      const idInput = addToCartForm.querySelector('input[name="id"]');
      if (!idInput) return;

      const variantId = idInput.value;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Error adding to cart');
          }
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (response) {
          return response.json();
        })
  .then(function (cart) {
  updateCartCount(cart.item_count);


  if (cartType === 'drawer') {
    openCartDrawer();
  } else if (cartType === 'page') {
    window.location.href = '/cart';
  }
})
        .catch(function (error) {
          console.error('Error adding to cart:', error);
        });
    });
  }
  /* =========================================================
     MM AUTO OPEN CART AFTER ADD — UNIVERSAL SAFETY
  ========================================================= */

  let mmCartWatchTimer = null;


  function mmWatchCartAndOpen() {

    /*
      Nombre d'articles avant l'ajout
    */

    const countBefore =

      parseInt(

        cartCountElement
          ? cartCountElement.textContent
          : '0',

        10

      ) || 0;


    /*
      Annule un ancien watcher éventuel
    */

    if (mmCartWatchTimer) {

      clearInterval(
        mmCartWatchTimer
      );

      mmCartWatchTimer = null;

    }


    let attempts = 0;


    /*
      On vérifie le vrai panier Shopify
      pendant quelques secondes.
    */

    mmCartWatchTimer = setInterval(
      function () {

        attempts++;


        fetch(
          '/cart.js',
          {
            cache: 'no-store',
            headers: {
              'Accept': 'application/json'
            }
          }
        )

        .then(function (response) {

          if (!response.ok) {

            throw new Error(
              'Unable to check cart'
            );

          }

          return response.json();

        })

        .then(function (cart) {

          /*
            Dès que Shopify confirme
            l'ajout réel du produit
          */

          if (
            cart.item_count > countBefore
          ) {

            clearInterval(
              mmCartWatchTimer
            );

            mmCartWatchTimer = null;


            updateCartCount(
              cart.item_count
            );


            /*
              Ouvre le vrai drawer
              desktop ET mobile
            */

            openCartDrawer();

            return;

          }


          /*
            Stop sécurité après environ 4 secondes
          */

          if (attempts >= 20) {

            clearInterval(
              mmCartWatchTimer
            );

            mmCartWatchTimer = null;

          }

        })

        .catch(function (error) {

          console.error(
            'Cart watch error:',
            error
          );

        });

      },

      200
    );

  }


  /*
    Détecte tous les formulaires Shopify
    d'ajout au panier.
  */

  document.addEventListener(
    'submit',

    function (event) {

      const form =

        event.target &&
        event.target.closest

          ? event.target.closest(
              'form[action*="/cart/add"], #AddToCartForm'
            )

          : null;


      if (!form) return;


      mmWatchCartAndOpen();

    },

    true
  );


  /*
    Sécurité supplémentaire pour les thèmes
    qui utilisent un bouton AJAX sans submit classique.
  */

  document.addEventListener(
    'click',

    function (event) {

      const button =

        event.target &&
        event.target.closest

          ? event.target.closest(
              '.product-info__cart-btn, button[name="add"], [data-add-to-cart]'
            )

          : null;


      if (!button) return;


      mmWatchCartAndOpen();

    },

    true
  );
  bindCartTriggers(document);
  attachRemoveHandlers();
  attachQuantityHandlers();

  document.addEventListener('shopify:section:load', function (event) {
    bindCartTriggers(event.target);
    attachRemoveHandlers();
    attachQuantityHandlers();
  });
});


/// Product cards ///
(function () {
  function setActiveImage(images, index) {
    if (!images || !images.length) return 0;
    var safeIndex = ((index % images.length) + images.length) % images.length;
    for (var i = 0; i < images.length; i++) {
      images[i].classList.toggle('is-active', i === safeIndex);
    }
    return safeIndex;
  }

  function initOneCard(card) {
    if (!card || card.dataset.productCardBound === 'true') return;
    card.dataset.productCardBound = 'true';

    var container = card.querySelector('.product-image-container');
    if (!container) return;

    var link = container.querySelector('a.product-list__img-link');
    if (!link) return;

    var images = Array.from(link.querySelectorAll('img.product-card__image'));
    if (!images.length) return;

    var hasMultiple = images.length > 1;
    var index = 0;

    var prevBtn = container.querySelector('.product-card-arrow--prev');
    var nextBtn = container.querySelector('.product-card-arrow--next');
function isMobile() {
  return window.matchMedia('(max-width: 749px)').matches;
}

    function clampIndex(i) {
      if (!images.length) return 0;
      return ((i % images.length) + images.length) % images.length;
    }

    function setActiveDesktop(i) {
      index = clampIndex(i);
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });
    }

    function bindDesktop() {
      setActiveDesktop(0);

      if (!container.dataset.hoverBound) {
        container.dataset.hoverBound = 'true';

        container.addEventListener('mouseenter', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(1);
        });

        container.addEventListener('mouseleave', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(0);
        });
      }

      if (prevBtn && !prevBtn.dataset.bound) {
        prevBtn.dataset.bound = 'true';
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index - 1);
        });
      }

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index + 1);
        });
      }
    }

    var track = null;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dragging = false;
    var decided = false;
    var horizontal = false;
    var width = 1;

    function ensureMobileTrack() {
      if (!hasMultiple) {
        setActiveDesktop(0);
        return null;
      }

      track = link.querySelector('.product-card-track');
      if (!track) {
        track = document.createElement('div');
        track.className = 'product-card-track';

        images.forEach(function (img) {
          track.appendChild(img);
        });
        link.appendChild(track);

        images = Array.from(track.querySelectorAll('img.product-card__image'));
      }

      images.forEach(function (img) {
        img.classList.remove('is-active');
        img.style.position = 'relative';
        img.style.inset = '';
        img.style.opacity = '1';
        img.style.visibility = 'visible';
        img.style.pointerEvents = 'auto';
        img.style.flex = '0 0 100%';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.style.transition = 'none';
      });

      track.style.display = 'flex';
      track.style.height = '100%';
      track.style.willChange = 'transform';
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(0px)';

      index = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transform = 'translateX(' + (-index * width) + 'px)';

      return track;
    }

    function setTrackTranslate(px, instant) {
      if (!track) return;
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }

    function snapTo(i) {
      if (!track) return;
      index = clampIndex(i);
      dx = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(' + (-index * width) + 'px)';
    }

    function bindMobileDrag() {
      if (!hasMultiple) return;

      container.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobile()) return;
          if (!track) ensureMobileTrack();
          if (!track) return;
          if (!e.touches || !e.touches[0]) return;

          width = container.getBoundingClientRect().width || 1;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;

          dx = 0;
          dragging = true;
          decided = false;
          horizontal = false;

          track.style.transition = 'none';
          track.style.transform = 'translateX(' + (-index * width) + 'px)';
        },
        { passive: true }
      );

container.addEventListener(
  'touchmove',
  function (e) {
    if (!isMobile()) return;
    if (!dragging || !track) return;
    if (!e.touches || !e.touches[0]) return;

    var x = e.touches[0].clientX;
    var y = e.touches[0].clientY;

    var rawDx = x - startX;
    var rawDy = y - startY;

 if (!decided) {
  if (
    Math.abs(rawDx) > 12 &&
    Math.abs(rawDx) > Math.abs(rawDy) * 1.35
  ) {
    horizontal = true;
    decided = true;
  } else if (Math.abs(rawDy) > 8) {
    dragging = false;
    decided = true;
    return;
  }
}

if (!horizontal) return;

/*
  HOME MOBILE :
  ne jamais bloquer le scroll natif vertical.
  Les autres pages gardent le comportement existant.
*/
if (!document.body.classList.contains('template-index')) {
  e.preventDefault();
}

dx = rawDx;

    if (index === 0 && dx > 0) {
      dx *= 0.35;
    }

    if (
      index === images.length - 1 &&
      dx < 0
    ) {
      dx *= 0.35;
    }

    var base = -index * width;

    setTrackTranslate(
      base + dx,
      true
    );
  },
  { passive: false }
);

      container.addEventListener(
        'touchend',
        function () {
          if (!isMobile()) return;
          if (!track) return;

          if (!dragging) return;
          dragging = false;

          if (!horizontal) {
            snapTo(index);
            return;
          }

          var threshold = width * 0.2;
          if (dx < -threshold) snapTo(index + 1);
          else if (dx > threshold) snapTo(index - 1);
          else snapTo(index);
        },
        { passive: true }
      );
    }

function applyMode() {
  images = Array.from(link.querySelectorAll('img.product-card__image'));
  hasMultiple = images.length > 1;

  if (isMobile()) {
    ensureMobileTrack();
    return;
  }

  /* Retour desktop : on retire proprement le track créé sur mobile */
  if (track && track.parentNode === link) {
    while (track.firstChild) {
      link.insertBefore(track.firstChild, track);
    }

    track.remove();
    track = null;

    images = Array.from(
      link.querySelectorAll('img.product-card__image')
    );
  }

  images.forEach(function (img) {
    img.style.position = '';
    img.style.inset = '';
    img.style.flex = '';
    img.style.width = '';
    img.style.height = '';
    img.style.objectFit = '';
    img.style.transition = '';
    img.style.opacity = '';
    img.style.visibility = '';
    img.style.pointerEvents = '';
  });

  index = 0;
  setActiveDesktop(0);
}

    bindDesktop();
    bindMobileDrag();
    applyMode();

if (!card.dataset.productCardResizeBound) {
  card.dataset.productCardResizeBound = 'true';

  var resizeTimer = null;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      applyMode();
    }, 80);
  });
}
  }

  function initAll(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-product-card]');
    cards.forEach(function (card) {
      initOneCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);

    var grid =
      document.querySelector('#CollectionProductGrid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.collection-grid') ||
      document.querySelector('.product-list') ||
      document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-card]')) {
            initOneCard(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


/// Footer Big Logo Fit — FONT SAFE / MOBILE SAFE ///
(function () {

  var resizeTimer = null;
  var frameId = null;


  function fitOneFooterLogo(el) {

    var cropWrap =
      el.closest('.footer__big-logo-crop');

    var fitWrap =
      el.closest('.footer__big-logo-fit');

    if (!cropWrap || !fitWrap) return;


    /*
      Reset complet avant nouvelle mesure.
    */

    el.style.setProperty(
      '--fit',
      '1'
    );

    el.style.setProperty(
      '--cropShift',
      '0px'
    );

    cropWrap.style.removeProperty(
      '--cropH'
    );


    /*
      Mesure avec la police actuellement réellement chargée.
    */

    var wrapW =
      fitWrap.getBoundingClientRect().width;

    var textW =
      el.scrollWidth;

    if (!wrapW || !textW) return;


    var scale =
      wrapW / textW;


    el.style.setProperty(
      '--fit',
      String(scale)
    );


    /*
      On attend que le transform soit réellement appliqué
      avant de mesurer la hauteur finale.
    */

    requestAnimationFrame(function () {

      requestAnimationFrame(function () {

        var scaledH =
          el.getBoundingClientRect().height;

        var cropPercent =
          parseFloat(
            getComputedStyle(cropWrap)
              .getPropertyValue('--crop')
          ) || 0;


        var cropPx =
          scaledH *
          (cropPercent / 100);


        var finalH =
          Math.max(
            0,
            scaledH - cropPx
          );


        cropWrap.style.setProperty(
          '--cropH',
          finalH + 'px'
        );


        el.style.setProperty(
          '--cropShift',
          cropPx + 'px'
        );

      });

    });

  }


  function fitAllFooterLogos(root) {

    var scope =
      root || document;


    scope
      .querySelectorAll(
        '.footer__big-logo-text'
      )
      .forEach(function (el) {

        fitOneFooterLogo(el);

      });

  }


  function scheduleFooterFit(root) {

    if (frameId) {
      cancelAnimationFrame(frameId);
    }


    frameId =
      requestAnimationFrame(function () {

        requestAnimationFrame(function () {

          fitAllFooterLogos(
            root || document
          );

        });

      });

  }


  /*
    Premier rendu DOM.
  */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      scheduleFooterFit(document);

    }
  );


  /*
    Toutes les ressources terminées.
  */

  window.addEventListener(
    'load',
    function () {

      scheduleFooterFit(document);

    }
  );


  /*
    CRUCIAL :
    recalcul après chargement réel des polices.
  */

  if (
    document.fonts &&
    document.fonts.ready
  ) {

    document.fonts.ready.then(function () {

      scheduleFooterFit(document);

    });

  }


  /*
    Certaines polices peuvent se charger après fonts.ready
    suivant Safari / cache / navigation.
  */

  if (
    document.fonts &&
    document.fonts.addEventListener
  ) {

    document.fonts.addEventListener(
      'loadingdone',
      function () {

        scheduleFooterFit(document);

      }
    );

  }


  /*
    Retour arrière Safari / BFCache.
  */

  window.addEventListener(
    'pageshow',
    function () {

      scheduleFooterFit(document);

    }
  );


  /*
    Shopify Editor.
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      scheduleFooterFit(
        event.target
      );

    }
  );


  /*
    Rotation téléphone / resize.
  */

  window.addEventListener(
    'resize',
    function () {

      clearTimeout(resizeTimer);

      resizeTimer =
        setTimeout(function () {

          scheduleFooterFit(document);

        }, 120);

    },
    {
      passive: true
    }
  );


  /*
    Sécurité supplémentaire :
    nouveau calcul après stabilisation mobile.
  */

  window.setTimeout(function () {

    scheduleFooterFit(document);

  }, 500);


  window.setTimeout(function () {

    scheduleFooterFit(document);

  }, 1500);

})();

/// Page Loader ///
(function () {
  var loader = document.getElementById('pageloader');
  if (!loader) return;

  var active = false;

  function show(noAnim) {
    if (active) return;
    active = true;

    if (noAnim) loader.classList.add('no-anim');
    loader.classList.add('show');

    if (noAnim) {
      requestAnimationFrame(function () {
        loader.classList.remove('no-anim');
      });
    }
  }

  function hide() {
    console.log('[PageLoader] Hiding');
    loader.classList.remove('show');
    active = false;

    document.documentElement.classList.remove('pageloader-hide-body');
    document.documentElement.classList.remove('pageloader-force-show');
  }

  document.addEventListener('DOMContentLoaded', function () {
    show(true);
  });

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', function () {
      console.log('[PageLoader] Window loaded');
      setTimeout(hide, 80);
    });
  }

  window.addEventListener('pageshow', function () {
    hide();
  });

  function samePage(href) {
    try {
      var u = new URL(href, location.href);
      return u.pathname === location.pathname && u.search === location.search;
    } catch (e) {
      return true;
    }
  }

function shouldHandle(a, e) {
  if (!a || e.defaultPrevented) return false;

  /* Ctrl / Cmd / Shift / Alt + clic */
  if (
    e.metaKey ||
    e.ctrlKey ||
    e.shiftKey ||
    e.altKey
  ) {
    return false;
  }

  /* Nouvel onglet ou autre target */
  if (
    a.target &&
    a.target !== '' &&
    a.target !== '_self'
  ) {
    return false;
  }

  /* Liens exclus explicitement du loader général */
  if (
    a.classList &&
    a.classList.contains('mm-no-page-transition')
  ) {
    return false;
  }

  if (
    a.closest &&
    a.closest('.mm-no-page-transition')
  ) {
    return false;
  }

  /* Panier */
  if (
    a.classList &&
    a.classList.contains('js-cart-toggle')
  ) {
    return false;
  }

  if (
    a.closest &&
    a.closest('.js-cart-toggle')
  ) {
    return false;
  }

  /* Wishlist + filtres */
  if (
    a.closest &&
    a.closest(
      '.mm-wishlist-nav, .mm-wishlist-header-link, [data-mm-filter-open], [data-mm-filter-close]'
    )
  ) {
    return false;
  }

  const href = a.getAttribute('href');

  if (!href) return false;

  /* Liens qui ne doivent pas naviguer avec le loader */
  if (
    href === '#' ||
    href === '' ||
    href.startsWith('javascript:') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:') ||
    href.startsWith('#')
  ) {
    return false;
  }

  /* Les produits ont leur propre transition */
  if (href.indexOf('/products/') !== -1) {
    return false;
  }

  /* MODE FEMME possède sa propre transition */
  if (
    a.classList &&
    a.classList.contains('explorer-btn') &&
    href.indexOf('/collections/femme') !== -1
  ) {
    return false;
  }

  /* Le panier drawer gère lui-même /cart */
  if (
    href.indexOf('/cart') !== -1 &&
    document.getElementById('CartDrawer')
  ) {
    return false;
  }

  /* Parents de sous-menu */
  if (
    a.closest &&
    a.closest('.menu-item') &&
    a.parentElement &&
    a.parentElement.querySelector(
      '.submenu, .dropdown, .sub-menu'
    )
  ) {
    return false;
  }

  try {
    const u = new URL(href, location.href);

    /* Lien externe */
    if (u.origin !== location.origin) {
      return false;
    }

    /* Même page */
    if (
      u.pathname === location.pathname &&
      u.search === location.search
    ) {
      return false;
    }
  } catch (error) {
    return false;
  }

  return true;
}



  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!shouldHandle(a, e)) return;

      e.preventDefault();
      show(false);

      setTimeout(function () {
        location.href = a.href;
      }, 60);
    },
    true
  );

  setTimeout(hide, 5000);
})();




/* ===== MM product logo transition ===== */
(function () {
  function isProductLink(a, e) {
    if (!a) return false;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (a.target && a.target !== "" && a.target !== "_self") return false;

    const href = a.getAttribute("href") || "";
    if (!href) return false;
    if (href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return false;
    if (href.includes("/cart") || href.includes("/checkout")) return false;

    return href.includes("/products/");
  }

  function playProductTransitionThenGo(href) {
    const overlay = document.getElementById("mmProductTransition");
    if (!overlay) {
      window.location.href = href;
      return;
    }

    overlay.classList.remove("is-on");
    void overlay.offsetWidth;
    overlay.classList.add("is-on");

    setTimeout(function () {
      window.location.href = href;
    }, 180);
  }

  document.addEventListener("click", function (e) {
    const a = e.target.closest("a");
    if (!isProductLink(a, e)) return;

    e.preventDefault();
    playProductTransitionThenGo(a.href);
  }, true);
})();
/* =========================================================
   MM NAVIGATION OVERLAYS — BACK/FORWARD CACHE RESET
========================================================= */

(function () {

  function resetMMNavigationOverlays() {

    var ids = [

      'mmProductTransition',

      'mmGlitchOverlay',

      'page-transition',

      'mmHomeTransition'

    ];


    ids.forEach(function (id) {

      var el =
        document.getElementById(id);

      if (!el) return;


      el.classList.remove(

        'is-on',

        'is-active',

        'show',

        'no-anim'

      );


      el.setAttribute(
        'aria-hidden',
        'true'
      );

    });


    /*
      Overlay FEMME éventuel.
    */
    document
      .querySelectorAll('.mm-glitch-femme')
      .forEach(function (el) {

        el.classList.remove(
          'is-active',
          'is-on'
        );

        el.setAttribute(
          'aria-hidden',
          'true'
        );

      });

  }


  /*
    pageshow se déclenche aussi lors d'un retour
    depuis le cache arrière/avant du navigateur.
  */
  window.addEventListener(
    'pageshow',
    function () {

      resetMMNavigationOverlays();


      /*
        Deuxième nettoyage après le premier repaint.
      */
      requestAnimationFrame(
        resetMMNavigationOverlays
      );


      /*
        Sécurité iOS supplémentaire.
      */
      setTimeout(
        resetMMNavigationOverlays,
        80
      );

    }
  );

})();

// ===== HERO 3D PARALLAX (mouse) =====
(() => {
  const hero = document.querySelector('.mm-couture-hero');
  if (!hero) return;

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  const strength = {
    move: 40,     // déplacement px (augmente = +parallax)
    tilt: 12,      // rotation deg (augmente = +3D)
    scaleMin: 1.18,
    scaleMax: 1.32
  };

  let raf = null;
  let tx = 0, ty = 0;

  function apply(){
    raf = null;

    // -1..1
    const x = tx;
    const y = ty;

    const px = clamp(x * strength.move, -strength.move, strength.move);
    const py = clamp(y * strength.move, -strength.move, strength.move);

    const ry = clamp(x * strength.tilt, -strength.tilt, strength.tilt);
    const rx = clamp(-y * strength.tilt, -strength.tilt, strength.tilt);

    // scale dynamique (plus tu vas sur les bords, plus ça "pop")
    const dist = Math.min(1, Math.hypot(x, y));
    const pz = strength.scaleMin + (strength.scaleMax - strength.scaleMin) * dist;

    hero.style.setProperty('--px', `${px}px`);
    hero.style.setProperty('--py', `${py}px`);
    hero.style.setProperty('--rx', `${rx}deg`);
    hero.style.setProperty('--ry', `${ry}deg`);
    hero.style.setProperty('--pz', `${pz}`);
  }

  hero.addEventListener('mousemove', (e) => {
    const r = hero.getBoundingClientRect();
    const cx = (e.clientX - r.left) / r.width;
    const cy = (e.clientY - r.top) / r.height;
    tx = (cx - 0.5) * 2;   // -1..1
    ty = (cy - 0.5) * 2;

    if (!raf) raf = requestAnimationFrame(apply);
  }, { passive: true });

  hero.addEventListener('mouseleave', () => {
    hero.style.setProperty('--px', `0px`);
    hero.style.setProperty('--py', `0px`);
    hero.style.setProperty('--rx', `0deg`);
    hero.style.setProperty('--ry', `0deg`);
    hero.style.setProperty('--pz', `1.18`);
  }, { passive: true });
})();
/* ===== MM: carousel reveal on view ===== */
(function(){
  const carousels = document.querySelectorAll('.carousel');
  if(!carousels.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(!entry.isIntersecting) return;
      const el = entry.target;
      el.classList.add('mm-reveal-in');
      io.unobserve(el);
    });
  }, { threshold: 0.25 });

  carousels.forEach(el => {
    el.classList.add('mm-reveal-ready');
    io.observe(el);
  });
})();




/* ===== MM section reveal on scroll ===== */
(function(){
  const isSmallMobile = window.matchMedia('(max-width: 749px)').matches;

  const items = document.querySelectorAll(
    isSmallMobile
      ? '.image-banner-container, .bestseller, .mm-runway-video'
      : '.shopify-section, .image-banner-container, .product-list, .bestseller, .mm-runway-video'
  );

  if (!items.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('mm-in-view');
      io.unobserve(entry.target);
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -10% 0px'
  });

  items.forEach(el => {
    if (el.dataset.mmSectionRevealBound === 'true') return;

    el.dataset.mmSectionRevealBound = 'true';
    el.classList.add('mm-reveal');
    io.observe(el);
  });
})();
/* ===== MM premium product reveal — optimized single observer ===== */
(function () {
  let io = null;

  function getObserver() {
    if (io) return io;

    io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('mm-in-view');
        io.unobserve(entry.target);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -8% 0px'
    });

    return io;
  }

  function initReveal(root) {
    const scope = root || document;
    const items = scope.querySelectorAll('.product-list__product-block');

    if (!items.length) return;

    const observer = getObserver();

    items.forEach((item, index) => {
      if (item.dataset.mmRevealBound === 'true') return;

      item.dataset.mmRevealBound = 'true';
      item.classList.add('mm-product-reveal');
      var delayStep = window.matchMedia('(max-width: 749px)').matches ? 35 : 70;
var maxDelay = window.matchMedia('(max-width: 749px)').matches ? 175 : 350;
item.style.setProperty('--mm-delay', `${Math.min(index * delayStep, maxDelay)}ms`);
      observer.observe(item);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();






/* ===== MM stable header scroll — MOBILE SAFE ===== */
(function () {

  const header =
    document.getElementById(
      'shopify-section-header'
    );

  const root =
    document.documentElement;

  if (!header) return;


  let ticking = false;


  function updateHeaderState() {

    const y =
      window.scrollY ||
      window.pageYOffset ||
      0;

    const isMobile =
      window.matchMedia(
        '(max-width: 749px)'
      ).matches;


    /*
      MOBILE :
      jamais de mode header compact.
      On garde toujours la taille normale.
    */

    if (isMobile) {

      header.classList.remove(
        'mm-header-scrolled'
      );

    } else {

      /*
        DESKTOP :
        comportement compact existant conservé.
      */

      if (y > 40) {

        header.classList.add(
          'mm-header-scrolled'
        );

      } else {

        header.classList.remove(
          'mm-header-scrolled'
        );

      }

    }


    /*
      HOME RUNWAY :
      garde uniquement le changement visuel
      transparent / sombre selon le scroll.
      Cela ne doit pas compacter le header mobile.
    */

    if (
      root.classList.contains(
        'mm-home-runway'
      )
    ) {

      if (y > 40) {

        header.classList.add(
          'mm-home-runway-scrolled'
        );

      } else {

        header.classList.remove(
          'mm-home-runway-scrolled'
        );

      }

    } else {

      header.classList.remove(
        'mm-home-runway-scrolled'
      );

    }


    ticking = false;

  }


  function onScroll() {

    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(
      updateHeaderState
    );

  }


  updateHeaderState();


  window.addEventListener(
    'scroll',
    onScroll,
    {
      passive: true
    }
  );


  window.addEventListener(
    'resize',
    updateHeaderState,
    {
      passive: true
    }
  );

})();;

/* ===== MM page fade ===== */

window.addEventListener('load', function(){
  document.body.classList.add('mm-loaded');
});


/* ===== MM split title reveal ===== */
(function () {
  const titles = document.querySelectorAll('.banner-content_h2, .bestseller-content h2, .collection-title');

  titles.forEach((title) => {
    if (title.dataset.mmSplitBound === 'true') return;
    title.dataset.mmSplitBound = 'true';

    const text = title.textContent;
    title.textContent = '';
    title.classList.add('mm-split-title');

    [...text].forEach((char, index) => {
      const span = document.createElement('span');
      span.className = 'mm-char';
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.transitionDelay = `${index * 22}ms`;
      title.appendChild(span);
    });
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('mm-visible');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  document.querySelectorAll('.mm-split-title').forEach((el) => io.observe(el));
})();
/* ===== MM runway header overlay scroll ===== */
(function () {
  const root = document.documentElement;
  const header = document.getElementById('shopify-section-header');
  if (!root.classList.contains('mm-home-runway') || !header) return;

  function updateRunwayHeader() {
    if (window.scrollY > 40) {
      header.classList.add('mm-home-runway-scrolled');
    } else {
      header.classList.remove('mm-home-runway-scrolled');
    }
  }

  updateRunwayHeader();
   window.addEventListener('scroll', updateRunwayHeader, { passive: true });
})();
// ===== MM SORTING =====
document.addEventListener('DOMContentLoaded', function () {
  const sortSelect = document.getElementById('SortBy');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });
});
/* =========================================================
   MM WISHLIST — LOCAL STORAGE SYSTEM
========================================================= */
(function () {
  const STORAGE_KEY = 'mm_wishlist_items_v1';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function normalizeUrl(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname;
    } catch (e) {
      return url || '';
    }
  }

  function isSaved(url) {
    const cleanUrl = normalizeUrl(url);
    return getWishlist().some(function (item) {
      return normalizeUrl(item.url) === cleanUrl;
    });
  }

  function heartIcon() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.8 4.6c-1.7-1.8-4.5-1.8-6.2 0L12 7.2 9.4 4.6c-1.7-1.8-4.5-1.8-6.2 0-1.8 1.9-1.8 4.9 0 6.8L12 20.5l8.8-9.1c1.8-1.9 1.8-4.9 0-6.8Z"></path>
      </svg>
    `;
  }

  function getProductDataFromCard(card) {
    const link =
      card.querySelector('a.product-list__img-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    if (!link) return null;

    const titleEl = card.querySelector('.product-list__product-name');
    const priceEl = card.querySelector('.product-list__product-price');
    const imageEl =
      card.querySelector('img.product-list__product-img') ||
      card.querySelector('img.product-card__image') ||
      card.querySelector('img');

    const title =
      titleEl && titleEl.textContent.trim()
        ? titleEl.textContent.trim()
        : link.getAttribute('aria-label') || 'Produit Maison Montaigne';

    return {
      url: link.href,
      title: title,
      price: priceEl ? priceEl.textContent.trim() : '',
      image: imageEl ? (imageEl.currentSrc || imageEl.src || '') : ''
    };
  }

  function getProductDataFromProductPage() {
    const productUrl = window.location.href;
    const titleEl =
      document.querySelector('.product-info__title.product-title-pc') ||
      document.querySelector('.product-info__title-top') ||
      document.querySelector('.product-info__title') ||
      document.querySelector('h1');

    const priceEl =
      document.querySelector('[data-product-price-current]') ||
      document.querySelector('.product-price-block') ||
      document.querySelector('.product-info__price');

    const imageEl =
      document.querySelector('#gallery.figureImg img.product__item-img.active') ||
      document.querySelector('#gallery.figureImg img.product__item-img') ||
      document.querySelector('.product-info__img') ||
      document.querySelector('.figureImg img');

    return {
      url: productUrl,
      title: titleEl ? titleEl.textContent.trim() : document.title,
      price: priceEl ? priceEl.textContent.trim() : '',
      image: imageEl ? (imageEl.currentSrc || imageEl.src || '') : ''
    };
  }

  function toggleWishlist(product) {
    if (!product || !product.url) return 'none';

    const cleanUrl = normalizeUrl(product.url);
    let items = getWishlist();

    const exists = items.some(function (item) {
      return normalizeUrl(item.url) === cleanUrl;
    });

    let action = 'none';

    if (exists) {
      items = items.filter(function (item) {
        return normalizeUrl(item.url) !== cleanUrl;
      });

      action = 'removed';
    } else {
      items.unshift({
        url: product.url,
        title: product.title || 'Produit Maison Montaigne',
        price: product.price || '',
        image: product.image || '',
        addedAt: Date.now()
      });

      action = 'added';
    }

    saveWishlist(items);
    refreshWishlistUI();

    return action;
  }
    function animateWishlistHeart(button) {
    if (!button) return;

    const headerHeart =
      document.querySelector('.mm-wishlist-nav .mm-header-wishlist-icon-wrap') ||
      document.querySelector('.mm-wishlist-header-link .mm-header-wishlist-icon-wrap') ||
      document.querySelector('.mm-wishlist-nav') ||
      document.querySelector('.mm-wishlist-header-link');

    if (!headerHeart) return;

    const buttonRect = button.getBoundingClientRect();
    const targetRect = headerHeart.getBoundingClientRect();

    const heart = document.createElement('div');
    heart.className = 'mm-wishlist-fly-heart';
    heart.innerHTML = heartIcon();

    heart.style.left = buttonRect.left + buttonRect.width / 2 + 'px';
    heart.style.top = buttonRect.top + buttonRect.height / 2 + 'px';

    document.body.appendChild(heart);

    const targetX = targetRect.left + targetRect.width / 2 - (buttonRect.left + buttonRect.width / 2);
    const targetY = targetRect.top + targetRect.height / 2 - (buttonRect.top + buttonRect.height / 2);

    requestAnimationFrame(function () {
      heart.style.transform =
        'translate(' + targetX + 'px, ' + targetY + 'px) scale(.32) rotate(-12deg)';
      heart.style.opacity = '0';
    });

    headerHeart.classList.add('mm-wishlist-heart-pulse');

    setTimeout(function () {
      heart.remove();
      headerHeart.classList.remove('mm-wishlist-heart-pulse');
    }, 760);
  }

  function createWishlistButton(product, buttonClass, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = buttonClass;
    button.innerHTML = heartIcon() + (label ? `<span>${label}</span>` : '');
    button.setAttribute('aria-label', 'Ajouter à la wishlist');
button.removeAttribute('title');
button.dataset.mmWishlistUrl = product.url;

        button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const action = toggleWishlist(product);

      if (action === 'added') {
        animateWishlistHeart(button);
      }
    });

    return button;
  }

  function initWishlistOnCards(root) {
    const scope = root || document;
    const cards = scope.querySelectorAll('.product-list__product-block');

    cards.forEach(function (card) {
      if (card.dataset.mmWishlistBound === 'true') return;

      const product = getProductDataFromCard(card);
      if (!product) return;

      card.dataset.mmWishlistBound = 'true';

      if (getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }

      const button = createWishlistButton(product, 'mm-wishlist-card-btn', '');
      card.appendChild(button);
    });
  }

  function initWishlistOnProductPage() {
    if (!window.location.pathname.includes('/products/')) return;

    const form = document.getElementById('AddToCartForm');
    const productMain = document.querySelector('.product-info__main');

    if (!form || !productMain || productMain.dataset.mmWishlistProductBound === 'true') return;

    productMain.dataset.mmWishlistProductBound = 'true';

    const product = getProductDataFromProductPage();
        const button = createWishlistButton(product, 'mm-product-wishlist-btn', 'Ajouter aux favoris');

    form.insertAdjacentElement('afterend', button);
  }

  function ensureWishlistDrawer() {
    if (document.querySelector('.mm-wishlist-drawer')) return;

    const overlay = document.createElement('div');
    overlay.className = 'mm-wishlist-overlay';

    const drawer = document.createElement('aside');
    drawer.className = 'mm-wishlist-drawer';
    drawer.setAttribute('aria-hidden', 'true');

    drawer.innerHTML = `
      <div class="mm-wishlist-drawer__header">
        <h2 class="mm-wishlist-drawer__title">Wishlist</h2>
        <button type="button" class="mm-wishlist-drawer__close" aria-label="Fermer">×</button>
      </div>
      <div class="mm-wishlist-drawer__content" data-mm-wishlist-content></div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

        overlay.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeWishlistDrawer();
    });

    drawer.querySelector('.mm-wishlist-drawer__close').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeWishlistDrawer();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeWishlistDrawer();
    });
  }

  function openWishlistDrawer() {
    ensureWishlistDrawer();
    renderWishlistDrawer();

    const overlay = document.querySelector('.mm-wishlist-overlay');
    const drawer = document.querySelector('.mm-wishlist-drawer');

    if (!overlay || !drawer) return;

    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mm-wishlist-open');
  }

  function closeWishlistDrawer() {
    const overlay = document.querySelector('.mm-wishlist-overlay');
    const drawer = document.querySelector('.mm-wishlist-drawer');

    if (overlay) overlay.classList.remove('is-open');

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('mm-wishlist-open');
  }

  function renderWishlistDrawer() {
    const content = document.querySelector('[data-mm-wishlist-content]');
    if (!content) return;

    const items = getWishlist();

    if (!items.length) {
      content.innerHTML = `
        <div class="mm-wishlist-empty">
          Aucun produit dans votre liste de souhaits pour le moment.
        </div>
      `;
      return;
    }

    content.innerHTML = items.map(function (item) {
      return `
        <div class="mm-wishlist-item" data-mm-wishlist-item="${normalizeUrl(item.url)}">
          ${
            item.image
              ? `<img class="mm-wishlist-item__image" src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">`
              : `<div class="mm-wishlist-item__image"></div>`
          }

          <div class="mm-wishlist-item__info">
            <a class="mm-wishlist-item__title" href="${item.url}">
              ${escapeHtml(item.title)}
            </a>

            ${
              item.price
                ? `<div class="mm-wishlist-item__price">${escapeHtml(item.price)}</div>`
                : ''
            }

            <div class="mm-wishlist-item__actions">
              <a class="mm-wishlist-item__view" href="${item.url}">Voir</a>
              <button type="button" class="mm-wishlist-item__remove" data-mm-wishlist-remove="${normalizeUrl(item.url)}">
                Retirer
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    content.querySelectorAll('[data-mm-wishlist-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        const url = this.dataset.mmWishlistRemove;
        const items = getWishlist().filter(function (item) {
          return normalizeUrl(item.url) !== url;
        });

        saveWishlist(items);
        renderWishlistDrawer();
        refreshWishlistUI();
      });
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initWishlistNav() {
  const rightNav = document.querySelector('.right-nav');
  if (!rightNav) return;

  let wishlistLink =
    rightNav.querySelector('.mm-wishlist-nav') ||
    rightNav.querySelector('.mm-wishlist-header-link') ||
    rightNav.querySelector('a[aria-label="Wishlist"]') ||
    rightNav.querySelector('a[href*="wishlist"]');

  if (!wishlistLink) {
    const cartLink = rightNav.querySelector('.js-cart-toggle');

    wishlistLink = document.createElement('a');
    wishlistLink.href = '#wishlist';

    wishlistLink.innerHTML = `
      <span class="mm-header-wishlist-icon-wrap" aria-hidden="true">
        <svg class="mm-header-wishlist-icon" viewBox="0 0 24 24" fill="none">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        </svg>
        <span class="mm-wishlist-count" data-mm-wishlist-count aria-hidden="true">0</span>
      </span>
    `;

    if (cartLink) {
      rightNav.insertBefore(wishlistLink, cartLink.nextSibling);
    } else {
      rightNav.appendChild(wishlistLink);
    }
  }

  wishlistLink.classList.add('mm-wishlist-nav');
  wishlistLink.classList.add('mm-wishlist-header-link');
  wishlistLink.setAttribute('aria-label', 'Wishlist');

  let countEl = wishlistLink.querySelector('[data-mm-wishlist-count]');

  if (!countEl) {
    countEl = document.createElement('span');
    countEl.className = 'mm-wishlist-count';
    countEl.setAttribute('data-mm-wishlist-count', '');
    countEl.setAttribute('aria-hidden', 'true');
    countEl.textContent = '0';

    const iconWrap = wishlistLink.querySelector('.mm-header-wishlist-icon-wrap') || wishlistLink;
    iconWrap.appendChild(countEl);
  }

  countEl.classList.add('mm-wishlist-count');

  document
  .querySelectorAll(
    '.mm-wishlist-nav, .mm-wishlist-header-link'
  )
  .forEach(function (link) {

    if (
      link.dataset.mmWishlistNavBound === 'true'
    ) {
      return;
    }


    link.dataset.mmWishlistNavBound = 'true';


    link.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        /*
          Ferme le menu mobile avant
          d'ouvrir le drawer Favoris.
        */
        var mobileMenu =
          document.querySelector('.header-menu');


        if (mobileMenu) {

          mobileMenu.classList.remove('active');

        }


        document.body.classList.remove(
          'mm-mobile-menu-open'
        );


        document.documentElement.classList.remove(
          'mm-mobile-menu-open'
        );


        document.body.style.removeProperty(
          'overflow'
        );


        document.documentElement.style.removeProperty(
          'overflow'
        );


        /*
          Referme les accordéons du menu mobile.
        */
        document
          .querySelectorAll(
            '.header-menu .menu-item.has-children.active'
          )
          .forEach(function (item) {

            item.classList.remove('active');

          });


        /*
          Ouvre les favoris existants.
        */
        openWishlistDrawer();

      }
    );

  });
}

  function refreshWishlistUI() {
  const items = getWishlist();
  const count = items.length;

  document.querySelectorAll('.mm-wishlist-nav, .mm-wishlist-header-link').forEach(function (link) {
    link.classList.toggle('has-count', count > 0);

    let countEl = link.querySelector('[data-mm-wishlist-count]');

    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'mm-wishlist-count';
      countEl.setAttribute('data-mm-wishlist-count', '');
      countEl.setAttribute('aria-hidden', 'true');

      const iconWrap = link.querySelector('.mm-header-wishlist-icon-wrap') || link;
      iconWrap.appendChild(countEl);
    }

    countEl.classList.add('mm-wishlist-count');
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'inline-flex' : 'none';
  });

  document.querySelectorAll('[data-mm-wishlist-count]').forEach(function (countEl) {
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'inline-flex' : 'none';
  });

  document.querySelectorAll('[data-mm-wishlist-url]').forEach(function (button) {
    const saved = isSaved(button.dataset.mmWishlistUrl);
    button.classList.toggle('is-active', saved);

           if (button.classList.contains('mm-product-wishlist-btn')) {
      const label = button.querySelector('span');
      if (label) {
        label.textContent = saved ? 'Dans vos favoris' : 'Ajouter aux favoris';
      }
    }

    button.setAttribute(
  'aria-label',
  saved ? 'Retirer de la wishlist' : 'Ajouter à la wishlist'
);
button.removeAttribute('title');
  });
}
  function initWishlist(root) {
    ensureWishlistDrawer();
    initWishlistNav();
    initWishlistOnCards(root || document);
    initWishlistOnProductPage();
    refreshWishlistUI();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWishlist(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWishlist(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initWishlist(event.target);
  });

  const observer = new MutationObserver(function (mutations) {
    let shouldRefresh = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches?.('.product-list__product-block') ||
          node.querySelector?.('.product-list__product-block')
        ) {
          initWishlist(node);
          shouldRefresh = true;
        }
      });
    });

    if (shouldRefresh) refreshWishlistUI();
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
/* ===== MM PRODUCT PAGE — RENAME WISHLIST BUTTON ===== */
(function(){
  function normalizeProductWishlistButton(){
    if (!document.documentElement.classList.contains('mm-product-page') &&
        !document.body.classList.contains('mm-product-page')) {
      return;
    }

    var candidates = Array.from(document.querySelectorAll('a, button'));

    candidates.forEach(function(el){
      var text = (el.textContent || '').trim().toLowerCase();

      if (
        text === 'liste de souhaits' ||
        text.includes('liste de souhaits')
      ) {
        el.classList.add('mm-product-wishlist-compact');

        el.childNodes.forEach(function(node){
          if (node.nodeType === Node.TEXT_NODE && node.textContent.toLowerCase().includes('liste de souhaits')) {
            node.textContent = node.textContent.replace(/Liste de souhaits/gi, 'Wishlist');
          }
        });

        if ((el.textContent || '').toLowerCase().includes('liste de souhaits')) {
          el.innerHTML = el.innerHTML.replace(/Liste de souhaits/gi, 'Wishlist');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', normalizeProductWishlistButton);
  window.addEventListener('load', normalizeProductWishlistButton);

  var observer = new MutationObserver(function(){
    normalizeProductWishlistButton();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
/* ===== MM COLLECTION FILTER DRAWER — FINAL STABLE ===== */
(function () {
  function initMMCollectionFilters(root) {
    var scope = root || document;

    var openBtn = scope.querySelector('[data-mm-filter-open]') || document.querySelector('[data-mm-filter-open]');
    var drawer = scope.querySelector('[data-mm-filter-drawer]') || document.querySelector('[data-mm-filter-drawer]');
    var overlay = scope.querySelector('.mm-filter-overlay') || document.querySelector('.mm-filter-overlay');

    if (!openBtn || !drawer || !overlay) return;

    /* Important : on sort le drawer du layout Shopify pour éviter les casses */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    if (openBtn.dataset.mmFilterFinalBound === 'true') return;
    openBtn.dataset.mmFilterFinalBound = 'true';

    function openFilters(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      document.body.classList.add('mm-filter-open');
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeFilters(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      document.body.classList.remove('mm-filter-open');
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', openFilters);

    document.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-mm-filter-close]');

      if (closeBtn) {
        closeFilters(event);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.body.classList.contains('mm-filter-open')) {
        closeFilters(event);
      }
    });

    overlay.addEventListener('click', closeFilters);

    var form = drawer.querySelector('form');
    if (form && form.dataset.mmFilterFormBound !== 'true') {
      form.dataset.mmFilterFormBound = 'true';

      form.addEventListener('submit', function () {
        document.body.classList.remove('mm-filter-open');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMMCollectionFilters(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initMMCollectionFilters(event.target);
  });
})();
/* MM Localization Switcher */
document.addEventListener('DOMContentLoaded', function () {
  const localization = document.querySelector('[data-mm-localization]');
  if (!localization) return;

  const trigger = localization.querySelector('.mm-localization__trigger');
  const panel = localization.querySelector('.mm-localization__panel');

  if (!trigger || !panel) return;

  let dormantTimer = null;

  function closePanel() {
    panel.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openPanel() {
    panel.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    wakeUp();
  }

  function setDormant() {
    if (!panel.hasAttribute('hidden')) return;
    localization.classList.add('is-dormant');
  }

  function clearDormantTimer() {
    if (dormantTimer) {
      clearTimeout(dormantTimer);
      dormantTimer = null;
    }
  }

  function startDormantTimer() {
    clearDormantTimer();
    dormantTimer = setTimeout(function () {
      setDormant();
    }, 1000);
  }

  function wakeUp() {
    localization.classList.remove('is-dormant');
    startDormantTimer();
  }

  trigger.addEventListener('click', function (event) {
    event.preventDefault();

    const isOpen = !panel.hasAttribute('hidden');

    if (isOpen) {
      closePanel();
      startDormantTimer();
    } else {
      openPanel();
    }
  });

  localization.addEventListener('mouseenter', function () {
    wakeUp();
  });

  localization.addEventListener('focusin', function () {
    wakeUp();
  });

  localization.addEventListener('touchstart', function () {
    wakeUp();
  }, { passive: true });

  document.addEventListener('click', function (event) {
    if (!localization.contains(event.target)) {
      closePanel();
      startDormantTimer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePanel();
      startDormantTimer();
    }
  });

  startDormantTimer();
});
/* =========================================================
   MM MOBILE SCROLL GUARD — CLEAR STALE LOCKS ONLY
========================================================= */

(function () {

  function isMobile() {
    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;
  }


  function exists(selector) {
    return !!document.querySelector(selector);
  }


  function repairMobileScrollState() {

    if (!isMobile()) return;


    /*
      Vérification des interfaces réellement ouvertes.
    */

    var menuOpen =
      exists('.header-menu.active');


    var cartOpen =
      exists(
        '#CartDrawer.open, ' +
        '.cart-drawer.open, ' +
        '.cart-drawer.is-open'
      );


    var wishlistOpen =
      exists(
        '.mm-wishlist-drawer.is-open'
      );


    var filterOpen =
      exists(
        '.mm-filter-drawer.is-open'
      );


    var productLightboxOpen =
      exists(
        '.mm-product-lightbox.is-open'
      );


    var articleModalOpen =
      exists(
        '.mm-article-modal.is-open'
      );


    var brandFilmOpen =
      exists(
        '.mm-brand-film-lightbox.is-open'
      );


    var artistModalOpen =
      exists(
        '.mmartist-modal.is-open'
      );


    /*
      MENU MOBILE
      Si le menu visuel est fermé,
      sa classe de blocage ne doit pas rester.
    */

    if (!menuOpen) {

      document.body.classList.remove(
        'mm-mobile-menu-open'
      );

      document.documentElement.classList.remove(
        'mm-mobile-menu-open'
      );

    }


    /*
      PANIER
    */

    if (!cartOpen) {

      document.body.classList.remove(
        'mm-cart-open'
      );

    }


    /*
      WISHLIST
    */

    if (!wishlistOpen) {

      document.body.classList.remove(
        'mm-wishlist-open'
      );

    }


    /*
      FILTRES
    */

    if (!filterOpen) {

      document.body.classList.remove(
        'mm-filter-open'
      );

    }


    /*
      LIGHTBOX PRODUIT
    */

    if (!productLightboxOpen) {

      document.body.classList.remove(
        'mm-product-lightbox-open'
      );

    }


    /*
      MODAL ARTICLE
    */

    if (!articleModalOpen) {

      document.body.classList.remove(
        'mm-article-modal-open'
      );

      document.documentElement.classList.remove(
        'mm-article-modal-open'
      );

    }


    /*
      BRAND FILM
    */

    if (!brandFilmOpen) {

      document.body.classList.remove(
        'mm-brand-film-open'
      );

    }


    /*
      On ne libère les styles inline
      que si AUCUNE interface bloquante
      n'est réellement ouverte.
    */

    var anyLockedUI =

      menuOpen ||
      cartOpen ||
      wishlistOpen ||
      filterOpen ||
      productLightboxOpen ||
      articleModalOpen ||
      brandFilmOpen ||
      artistModalOpen;


    if (!anyLockedUI) {

      document.body.style.removeProperty(
        'overflow'
      );

      document.body.style.removeProperty(
        'height'
      );

      document.documentElement.style.removeProperty(
        'overflow'
      );

      document.documentElement.style.removeProperty(
        'height'
      );

    }

  }


  /*
    Retour arrière / avant navigateur.
  */

  window.addEventListener(
    'pageshow',
    function () {

      repairMobileScrollState();

      requestAnimationFrame(
        repairMobileScrollState
      );

      setTimeout(
        repairMobileScrollState,
        80
      );

    }
  );


  /*
    Chargement normal.
  */

  window.addEventListener(
    'load',
    function () {

      setTimeout(
        repairMobileScrollState,
        0
      );

    }
  );


  /*
    Retour dans Safari / Chrome
    après changement d'onglet.
  */

  document.addEventListener(
    'visibilitychange',
    function () {

      if (!document.hidden) {

        setTimeout(
          repairMobileScrollState,
          0
        );

      }

    }
  );


  /*
    Navigation arrière / avant.
  */

  window.addEventListener(
    'popstate',
    function () {

      setTimeout(
        repairMobileScrollState,
        0
      );

    }
  );


  /*
    Sécurité après une interaction tactile.
    Ne débloque rien si un vrai menu,
    drawer ou modal est ouvert.
  */
/*
  Nettoyage préventif AVANT le début du geste.
  Si aucune UI bloquante n'est réellement ouverte,
  les anciens locks sont supprimés avant le swipe.
*/

document.addEventListener(
  'touchstart',
  function () {
    repairMobileScrollState();
  },
  {
    passive: true,
    capture: true
  }
);
  document.addEventListener(
    'touchend',
    function () {

      setTimeout(
        repairMobileScrollState,
        0
      );

    },
    { passive: true }
  );

})();